import React, { useEffect, useState } from "react";
import { Modal, FormGroup, ControlLabel, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Spinner } from "../Utils/Loaders";
import { CustomSelect } from "../CustomControls/CustomSelect";
import { getDevices } from "../../api/devices";
import { HandleApiError } from "../Notifications/APIErrorHandler";

export const ModalAssignDeviceToStartup = ({ show, onClose, onSave, assignedDeviceIds = [] }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    devices: [],
  });

  const query = {
    pagination: {
      page: 1,
      sizePerPage: 1000,
      totalSize: 0,
    },
    sort: {
      sortField: "Created",
      sortOrder: "desc",
    },
    filters: {},
  };

  useEffect(() => {
    const fetchData = () => {
      setIsLoading(true);
      getDevices(query)
        .then((response) => {
          const paginatedResult = response.data;
          // Filtrar dispositivos ya asignados
          const availableDevices = paginatedResult.data.filter(
            (device) => !assignedDeviceIds.includes(device.id)
          );
          setData(availableDevices);
          setIsLoading(false);
        })
        .catch((error) => {
          HandleApiError(error);
          setIsLoading(false);
        });
    };

    fetchData();
  }, []);

  const handleChange = (field, selectedValue) => {
    setFormData((prev) => ({ ...prev, [field]: selectedValue || [] }));
  };

  const handleSubmit = async () => {
    const { devices } = formData;

    const payload = {
      deviceIds: devices.map((d) => d.id),
    };

    setSaving(true);

    onSave(payload, setSaving);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("devices.createModal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormGroup controlId="formDevice">
          <ControlLabel>{t("devices.createModal.deviceLabel")}</ControlLabel>
          <CustomSelect
            value={formData.devices}
            name="devices"
            placeholder={t("commons.select")}
            isDisabled={isLoading}
            options={data}
            onChange={handleChange}
            isMulti={true}
            closeMenuOnSelect={false}
            getOptionLabel={(x) => x.name}
            getOptionValue={(x) => x.id}
          />
        </FormGroup>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {t("devices.createModal.cancelLabel")}
        </Button>
        {saving && <Spinner />}
        {!saving && (
          <Button
            disabled={!formData.devices || formData.devices.length === 0 || isLoading}
            variant="btn btn-primary"
            onClick={handleSubmit}
          >
            {t("devices.createModal.acceptLabel")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
